import React, { useState, useEffect, useRef } from "react";
import "./BrandStock.css";

// components imports
import BrandsTable from "../../../Components/BoltTable/BoltTable";
import Confirm from "../../../Components/Popups/Confirm";
import AddBrand from "./Components/AddBrand/AddBrand";
import EditBrand from "./Components/EditBrand/EditBrand";
import Tooltip from "../../../Components/Tooltip/Tooltip";
// apis imports
import {
  getBrandsList,
  deleteBrand,
} from "../../../services/warehouse.services";
// library imports

import { MdOutlineCancel } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { FcPlus } from "react-icons/fc";
import noImage from "../../../assets/images/noImage.png";
import { showSnackBar } from "../../../store/common/snackBarSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const BrandStock = ({ snack }) => {
  const { t } = useTranslation(["inventory", "common"]);
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteLoader, setdeleteLoader] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [brands, setBrands] = useState([]);
  const dispatch = useDispatch();
  const columns = [
    {
      id: 1,
      label: t("brands.name"),
      render: (row) => <>{row?.name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("brands.code"),
      render: (row) => <>{row?.code ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: "logo",
      render: (row) => (
        <>
          <img
            src={row?.file || noImage}
            onError={(e) => {
              e.target.src = noImage;
            }}
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 4,
      label: t("brands.description"),
      render: (row) => <>{row?.description ?? "-"}</>,
      width: "200px",
    },
    {
      id: 5,
      label: t("brands.action"),
      render: (row) => (
        <>
          <div className="table_action__wrap">
            <Tooltip title={t("brands.editBrandDetails")}>
              <div
                className="table_action__btn"
                onClick={() => setEditOpen(row)}
              >
                <FaRegEdit size={10} />
                {t("common:actions.edit")}
              </div>
            </Tooltip>

            <Tooltip title={t("brands.deleteBrand")}>
              <div
                className="table_action__btn"
                onClick={() => setConfirmDelete(row)}
              >
                <MdOutlineCancel size={10} />
                {t("common:actions.delete")}
              </div>
            </Tooltip>
          </div>
        </>
      ),
      width: "200px",
    },
  ];

  const fetchBrandsList = async (page, perPage, filter) => {
    const response = await getBrandsList(page, perPage, filter);

    if (!response.error) {
      setBrands(response?.data?.result);
    } else {
      dispatch(
        showSnackBar({
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        })
      );
    }
  };

  const handleDeleteRequest = async (data) => {
    if (data.id) {
      setdeleteLoader(true);
      const response = await deleteBrand(data.id);
      if (!response.error && response?.data?.success) {
        setBrands((prevBrands) => {
          return {
            ...prevBrands,
            data: prevBrands?.data?.filter((b) => b?.id != data?.id),
          };
        });
        setdeleteLoader(false);
        setConfirmDelete(false);

        dispatch(
          showSnackBar({
            text: t("brands.requestDeletedSuccessfully"),
            severity: "success",
          })
        );
      } else {
        setdeleteLoader(false);
        dispatch(
          showSnackBar({
            text:
              response?.error?.response?.data?.message ||
              t("brands.couldntCancelThisRequest"),
            severity: "error",
          })
        );
      }
    }
  };

  return (
    <>
      <Confirm
        open={confirmDelete}
        setOpen={setConfirmDelete}
        handleConfirm={() => handleDeleteRequest(confirmDelete)}
        text={t("brands.deleteThisBrand")}
        loader={deleteLoader}
      />
      <div className="brands_header">
        <div>
          <span className="brands_hdrheading"></span>
        </div>
        <div className="brands_buttonsWrapper">
          <div onClick={() => setOpen(true)}>
            <div className="brands_hdraddprod">
              <FcPlus size={10} />
              <span>{t("brands.addBrandCaps")}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="brandStock__main_wrap">
        <div className="brandStock__table_list">
          <div>
            <BrandsTable
              tableTitle={t("brands.brands")}
              tableId="brandStockTableForProdcut"
              message={t("brands.noBrandsAvailableToDisplay")}
              searchPlaceHolder={t("brands.searchBrands")}
              columns={columns}
              data={brands}
              getAllData={fetchBrandsList}
              refresh={refresh}
            />
          </div>
        </div>
        <AddBrand open={open} setOpen={setOpen} setRefresh={setRefresh} />
        <EditBrand
          open={editOpen}
          setOpen={setEditOpen}
          setBrands={setBrands}
        />
      </div>
    </>
  );
};

export default BrandStock;
